var _fn = function () {};

function LoadMore(config) {
    var dftCfg = {
        btn: $(".load-more"),
        hide: true,
        prevent: _fn,
        trigger: "scroll"

    };

    this.config = $.extend({}, dftCfg, config);

    this.loadMoreBtn = this.config.btn;
    this.canLoadFlag = !this.config.hide;

    this.$mod = this.config.mod;

    this.lazyLoad();

}

LoadMore.prototype = {
    btn: function () {
        return this.loadMoreBtn;
    },
    enable: function () {
        this.canLoadFlag = true;
    },
    disable: function () {
        this.canLoadFlag = false;
    },

    trigger: function (cb) {
        var that = this;

        if (this.config.hide) {
            return;
        }

        $(window).on('scroll', _.throttle(function () {
            

            if (typeof that.config.prevent === 'function' && that.config.prevent()) {
                return;
            }
            if (that.canLoadFlag && that.loadMoreBtn) {
                var scrollHeight = window.scrollY || document.body.scrollTop || $(window).scrollTop(),
                    documentHeight = document.body.scrollHeight || document.body.offsetHeight || $('body').height(),
                    deviceHeight = window.innerHeight ||  document.documentElement.clientHeight || $(window).height();
                var isSafari = navigator.userAgent.indexOf("Safari") > -1;

                var cond = that.config.trigger === "scroll" ?
                    isSafari ?
                    scrollHeight >= documentHeight - (deviceHeight + 50) :
                    scrollHeight >= documentHeight - deviceHeight :
                    scrollHeight >= that.loadMoreBtn.offset().top + that.loadMoreBtn
                    .outerHeight() - deviceHeight;

                if (cond) {
                    that.canLoadFlag = false;

                    that.loadMoreBtn.siblings('.icon').addClass('loading');
                    if (that.config.trigger === "pcScroll") {
                        that.loadMoreBtn.html('<em></em>正在加载更多');

                        that.scrollLoc = $(document).scrollTop();

                    } else {
                        that.loadMoreBtn.html('加载中');

                    }

                    if (typeof cb === 'function') {
                        cb();
                    }
                }
            }
        }, 200))

    },

    lazyLoad: function () {
        if (this.$mod) {
            this.$mod.find('.lazy-img').lazyload({
                threshold: 80,
                effect: "fadeIn"

            });
        }

    },

    renderMore: function (list_tpl, context, wrapper) {
        var Velocity = window.velocityjs;

        var html = Velocity.render(list_tpl, context)

        wrapper.html(wrapper.html() + html);

        this.lazyLoad();
    },

    hide: function () {

        this.canLoadFlag = true;
        this.loadMoreBtn.hide();
    },


    show: function () {
        this.canLoadFlag = true;
        if (this.config.trigger === "scroll") {
            this.loadMoreBtn.html('上滑加载更多...').removeClass('loading').show();

        } else if (this.config.trigger === "pcScroll") {
            this.goBack();
            this.loadMoreBtn.html('滑动加载更多').show();

        }
    },

    noMore: function () {
        if (this.config.trigger === "scroll") {
            this.canLoadFlag = false;

            this.loadMoreBtn.siblings('.icon').removeClass('loading').addClass('smile');
            this.loadMoreBtn.html('没有啦');
        } else if (this.config.trigger === "pcScroll") {
            this.canLoadFlag = false;
            this.goBack();
            this.loadMoreBtn.remove();
        }
    },


    noMorePost: function () {
        if (this.config.trigger === "scroll") {
            this.canLoadFlag = false;

            this.loadMoreBtn.siblings('.icon').removeClass('loading').removeClass('smile');
            this.loadMoreBtn.html('只展示当前用户30条帖子');

        } else if (this.config.trigger === "pcScroll") {
            this.canLoadFlag = false;

            this.loadMoreBtn.html('只展示当前用户30条帖子');

        }
    },

    goBack: function () {
        if (this.config.trigger === "pcScroll") {

            $(document).scrollTop(this.scrollLoc)
        };
    }

};

module.exports = LoadMore;



//////////////////
// WEBPACK FOOTER
// ./src/assets/loadMore.js
// module id = 56
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 20 21 22 23 24 25 26 27 28 29 30 31 32 33